<template>
  <div class="tw:relative">
    <BaseCard
      v-if="isMenuOpen"
      v-click-outside="onClickaway"
      no-padding
      class="tw:absolute tw:z-10 tw:flex tw:min-w-[300px] tw:w-[calc(100%-20px)] tw:xs:min-w-[340px] tw:mx-[10px] menu-card-mobile tw:rounded-xl tw:right-0"
    >
      <div class="tw:p-[15px] tw:w-full">
        <ul>
          <li>
            <button
              class="tw:items-center tw:text-sm tw:justify-between tw:py-1.5 tw:px-3 tw:hover:cursor-pointer tw:hover:bg-gray-200 tw:active:bg-gray-200 tw:rounded tw:mb-0 tw:w-full tw:flex tw:font-bold"
              :class="{ selected: isLanguageOpen }"
              @click="toggleLanguage"
              @keydown.enter="toggleLanguage"
            >
              {{ selectedLanguage.displayText }}
              <ChevronRight
                class="tw:hover:fill-blue-800 arrow-dropdown tw:fill-gray-800 tw:w-6 tw:h-[18px]"
              />
            </button>
          </li>
          <ul v-if="isLanguageOpen" class="tw:ml-6 tw:flex tw:gap-y-3 tw:flex-col">
            <li v-for="lang in selectableLanguages" :key="lang.value">
              <button
                @click="selectNewLanguage(lang)"
                class="tw:hover:no-underline tw:w-full tw:py-1 tw:px-1 tw:hover:text-gray-800 tw:flex tw:items-center tw:justify-between tw:hover:bg-blue-100 tw:text-sm tw:hover:rounded"
              >
                {{ $t(lang.displayText) }}
              </button>
            </li>
          </ul>
        </ul>
      </div>
    </BaseCard>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

import BaseCard from '@/components/dashboard/BaseCard.vue'
import ChevronRight from '@/components/icons/ChevronRight.svg?component'
import axios from '@/plugins/axios'

import { setI18nLanguage } from '@/plugins/i18n'
import { languages } from '@/constants/locales'
import { useSessionValues } from '@/composables/useSessionValues'

defineProps({
  isMenuOpen: Boolean,
})
const emit = defineEmits(['onClickaway'])
const onClickaway = () => emit('onClickaway')
const store = useStore()
const isLanguageOpen = ref(false)
const { language } = useSessionValues()
const toggleLanguage = () => {
  isLanguageOpen.value = !isLanguageOpen.value
}
const selectedLanguage = computed(() => languages.find(item => item.value === language.value))
const selectableLanguages = computed(() => languages.filter(item => item.value !== language.value))

const selectNewLanguage = lang => {
  updateAppLanguage(lang)
  isLanguageOpen.value = false
  emit('onClickaway')
}

async function updateAppLanguage(lang) {
  const isSupportedLanguage = languages.find(item => item.value === lang.value)
  const newLanguage = isSupportedLanguage ? lang.value : 'en-US'

  store.commit('SET_LANGUAGE', newLanguage)
  await setI18nLanguage(newLanguage)

  axios.defaults.headers.common['Accept-Language'] = newLanguage
}
</script>
<style scoped>
.arrow-dropdown {
  top: 1px;
  bottom: 0;
  height: 100%;
  right: 0;
  pointer-events: none;
  transform: translateY(0%) rotate(90deg);
}
.selected .arrow-dropdown {
  transform: translateY(0%) rotate(-90deg);
  fill: var(--tw-color-blue-700);
}
.selected {
  background-color: var(--tw-color-white);
  margin-bottom: 0;
}
.menu-card-mobile {
  top: 10px;
}
</style>
